// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__Kwjb6","blue":"Welcome_blue__BKTj2","logo":"Welcome_logo__8kU7Z"};